import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "admin-layout" }
const _hoisted_2 = { class: "admin-layout__logo" }
const _hoisted_3 = {
  key: 0,
  class: "admin-layout__logo-text"
}
const _hoisted_4 = { class: "admin-layout__nav" }
const _hoisted_5 = { class: "admin-layout__main" }
const _hoisted_6 = { class: "admin-layout__header" }
const _hoisted_7 = { class: "admin-layout__header-right" }
const _hoisted_8 = { class: "admin-layout__content" }

import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import { Expand, Fold } from '@element-plus/icons-vue';
import { HpsfirSideBar, HpsfirUserBar, useBaseUserStore } from 'hpsfir-managebase-ui';
import { useApi } from '@/hooks/useApi';
import defaultAvatar from '@/assets/avatar.png';


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminLayout',
  setup(__props) {

const route = useRoute();
const userStore = useBaseUserStore();

// 侧边栏折叠状态
const sidebarCollapsed = ref(false);

// 切换侧边栏
const toggleSidebar = () => {
  sidebarCollapsed.value = !sidebarCollapsed.value;
};


// 水印内容：根据版本动态生成
const watermarkContent = computed(() => {
  const userName = userStore?.username || userStore.meta?.userName || userStore.meta?.name || '未登录用户';

  return [userName];
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_watermark = _resolveComponent("el-watermark")!

  return (_openBlock(), _createBlock(_component_el_watermark, {
    content: watermarkContent.value,
    font: {
      color: 'rgba(91, 155, 213, 0.1)',
      fontSize: 16
    },
    "z-index": 100,
    gap: [150, 150]
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("aside", {
          class: _normalizeClass(["admin-layout__sidebar", { 'admin-layout__sidebar--collapsed': sidebarCollapsed.value }])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "admin-layout__logo-icon" }, null, -1)),
            _createVNode(_Transition, { name: "logo-fade" }, {
              default: _withCtx(() => [
                (!sidebarCollapsed.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[0] || (_cache[0] = [
                      _createElementVNode("div", { class: "admin-layout__logo-title" }, "DZ POKER", -1),
                      _createElementVNode("div", { class: "admin-layout__logo-subtitle" }, "管理后台", -1)
                    ]))]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("nav", _hoisted_4, [
            _createVNode(_unref(HpsfirSideBar), {
              "model-value": false,
              horizontal: false,
              fold: false
            }, {
              footer: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createElementVNode("div", { class: "admin-layout__footer-version" }, [
                  _createElementVNode("span", { class: "version-main" }, "v1.0.0")
                ], -1)
              ]))]),
              _: 1
            })
          ])
        ], 2),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("header", _hoisted_6, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "admin-layout__header-left" }, null, -1)),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_unref(HpsfirUserBar), {
                "enable-update-pw": true,
                "default-avatar": _unref(userStore).meta?.avatar ? `${_unref(useApi)().baseUrl}${_unref(userStore).meta?.avatar}` : _unref(defaultAvatar)
              }, null, 8, ["default-avatar"])
            ])
          ]),
          _createElementVNode("main", _hoisted_8, [
            _createVNode(_component_el_scrollbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_router_view)
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["content"]))
}
}

})